import { render, staticRenderFns } from "./DialogQueueDisplay.vue?vue&type=template&id=7b21ee66&scoped=true"
import script from "./DialogQueueDisplay.vue?vue&type=script&lang=ts"
export * from "./DialogQueueDisplay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b21ee66",
  null
  
)

export default component.exports